import React from 'react';
import { Button as ButtonBase } from '@cp/ds/src/components/button';
import { HeartIcon } from '@cp/ds/src/icons/heart';
import { HeartFilledIcon } from '@cp/ds/src/icons/heartFilled';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useIsFavorite } from '@cp/entities/client/current/favorite/model/useIsFavorite';
import { currentClientFavoriteApi } from '@cp/entities/client/current/favorite';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { useToggleFavorite } from 'src/features/client/current/favorite';
// import { useClientLogin } from 'src/features/client/current/login';
import { withTrackClick } from 'src/shared/tracking';
import { CatalogEvents } from 'src/features/catalog';
import { useAuthInterceptor } from 'src/features/auth';
import { FavoriteProps } from './model';

const Button = withTrackClick(ButtonBase, CatalogEvents.ItemLike);

export const Favorite: React.FC<FavoriteProps> = ({ author, ...restProps }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const loggedIn = useIsLoggedIn();
  // const login = useClientLogin();
  const toggleFavorite = useToggleFavorite(author.id);
  const { isLoading } = currentClientFavoriteApi.endpoints.getFavoriteClientsList.useQuery(undefined, { skip: !loggedIn });
  const isFavorite = useIsFavorite(author.id);
  const withAuth = useAuthInterceptor();
  const onClick = withAuth(toggleFavorite);

  const favoriteButtonLabel = isFavorite ? 'Избранное' : 'Мне нравится';
  const favoriteButtonColor = theme.palette[isFavorite ? 'brand pink' : 'brand gray'];
  const ActionIcon = isFavorite ? HeartFilledIcon : HeartIcon;

  return (
    <Button
      disabled={isLoading}
      iconRight={<ActionIcon sx={{ color: favoriteButtonColor }} />}
      onClick={() => onClick()}
      square={isMobile}
      variant="secondary"
      {...restProps}
      sx={mergeSx({ backgroundColor: theme.palette.white }, restProps?.sx)}
    >
      {isMobile ? <ActionIcon fontSize="large" sx={{ color: favoriteButtonColor }} /> : favoriteButtonLabel}
    </Button>
  );
};
